var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// react/airplane-42.js
import React from "react";
import { i18n as i18n2 } from "@lingui/core";

// src/raw/airplane/locales/nb/messages.mjs
var messages = JSON.parse('{"icon.title.airplane":["Fly"]}');

// src/raw/airplane/locales/en/messages.mjs
var messages2 = JSON.parse('{"icon.title.airplane":["Airplane"]}');

// src/raw/airplane/locales/fi/messages.mjs
var messages3 = JSON.parse('{"icon.title.airplane":["Lentokone"]}');

// src/raw/airplane/locales/da/messages.mjs
var messages4 = JSON.parse('{"icon.title.airplane":["Flyvemaskine"]}');

// src/raw/airplane/locales/sv/messages.mjs
var messages5 = JSON.parse('{"icon.title.airplane":["Flygplan"]}');

// src/utils/i18n.ts
import { i18n } from "@lingui/core";
var supportedLocales = ["en", "nb", "fi", "da", "sv"];
var defaultLocale = "en";
var detectByBrand = () => {
  var _a;
  let value;
  switch ((_a = process == null ? void 0 : process.env) == null ? void 0 : _a.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname == null ? void 0 : hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale;
  }
};
var getSupportedLocale = (usedLocale) => {
  return supportedLocales.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost();
};
function detectLocale() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand();
    return getSupportedLocale(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost();
    if (!supportedLocales.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale(hostLocale);
    }
    return getSupportedLocale(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale;
  }
}
var getMessages = (locale, enMsg, nbMsg, fiMsg, daMsg, svMsg) => {
  if (locale === "nb") return nbMsg;
  if (locale === "fi") return fiMsg;
  if (locale === "da") return daMsg;
  if (locale === "sv") return svMsg;
  return enMsg;
};
var activateI18n = (enMessages, nbMessages, fiMessages, daMessages, svMessages) => {
  const locale = detectLocale();
  const messages6 = getMessages(locale, enMessages, nbMessages, fiMessages, daMessages, svMessages);
  i18n.load(locale, messages6);
  i18n.activate(locale);
};

// react/airplane-42.js
activateI18n(messages2, messages, messages3, messages4, messages5);
var title = i18n2.t({ message: `Airplane`, id: "icon.title.airplane", comment: "Title for airplane icon" });
var IconAirplane42 = (attrs) => React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "42", height: "28", fill: "none", viewBox: "0 0 42 28", dangerouslySetInnerHTML: { __html: `<title>${title}</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16.286 14.143h-4.408a3.3 3.3 0 0 1-1.688-.414c-.52-.287-.96-.71-1.277-1.227L3.857 3.857H7.2l4.68 3.429h22.835a3.429 3.429 0 0 1 0 6.857h-8.571"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m18.061 12.428-2.204 1.715 2.204 1.714h8.082v-3.428h-8.082Zm-7.346-1.714h-6m24.857 15.428a2.571 2.571 0 1 1 1.844-4.362 3.428 3.428 0 1 1 3.298 4.362zM9 18.428a2.57 2.57 0 0 0-2.514 2.02 1.67 1.67 0 0 0-.914-.305 1.715 1.715 0 0 0 0 3.428H9a2.571 2.571 0 1 0 0-5.143"></path>` } }, attrs));
var airplane_42_default = IconAirplane42;
export {
  IconAirplane42,
  airplane_42_default as default
};
//# sourceMappingURL=airplane-42.js.map
